import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/PnrStatusCard.css';
import '../../../styles/railSeoSprite.css';
import { getAppEnv } from '../../../../config/env';
import {
  CHECK_PNR_STATUS,
  CHECK_STATUS,
  ENTER_10Digit_PNR,
  IRCTC_AUTHORIZED_TICKETING,
  PNR_NUMBER,
  PNR_URL
} from '../constants/PnrSeoConstants';
import { isMobile } from '../../../utils/commonUtils';
import usePokusApi from '../../../hooks/usePokusApi';
import { POKUS_KEYS } from '../../../utils/RailsSEOConstants';

const env = getAppEnv();
const { MWEB_URL } = env.raw;

const PnrStatusCard = ({ customClass = '' }) => {
  const tgsPnrPage = usePokusApi(POKUS_KEYS.tgspnrPage, false) && !isMobile();
  const openPnrStatusPage = (e) => {
    e.preventDefault();
    const pnrInputVal = document.getElementById('pnrInputVal')?.value;
    if (!tgsPnrPage) {
      window.location.href = `${MWEB_URL}/railways/tgspnrsearch/?pnr=${pnrInputVal}`;
    } else {
      const pnrPageLink = PNR_URL + pnrInputVal;
      window.location.href = pnrPageLink;
    }
  };

  return (
    <div className={`pnrStatusCard ${customClass}`}>
      <div className="pnrStatusHeading">
        <span className="railSeoSprite railIcon appendRight20" />
        <div>
          <h1 className="latoBlack font22 lineHeight30 blackText">{CHECK_PNR_STATUS}</h1>
          <p className="font12 lineHeight16 latoRegular greyText">{IRCTC_AUTHORIZED_TICKETING}</p>
        </div>
      </div>
      <form id="pnrForm" className="pnrForm" action="/pnrInputVal" target="_top" onSubmit={openPnrStatusPage}>
        <div className="pnrNoWpr">
          <span className="latoBlack font12 lineHeight30 blackText">{PNR_NUMBER}</span>
          <input
            id="pnrInputVal"
            type="text"
            placeholder={ENTER_10Digit_PNR}
            maxLength={10}
            minLength={10}
            required
            title={ENTER_10Digit_PNR}
            pattern="[0-9]{10}"
            aria-label="Search"
          />
        </div>
      </form>
      <input type="submit" form="pnrForm" className={`bluePrimarybtn`} value={CHECK_STATUS} />
    </div>
  );
};

PnrStatusCard.propTypes = {
  customClass: PropTypes.string
};

export default PnrStatusCard;
